import { render, staticRenderFns } from "./sessionList.vue?vue&type=template&id=396ed6a1"
import script from "./sessionList.vue?vue&type=script&lang=js"
export * from "./sessionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports